import mapboxgl from 'mapbox-gl/dist/mapbox-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import MapboxWorker from 'mapbox-gl/dist/mapbox-gl-csp-worker'
mapboxgl.workerClass = MapboxWorker
import { distance } from '@turf/turf'
// import 'mapbox-gl/dist/mapbox-gl.css'
// import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
// import mapIcon from 'Images/icons/map.svg'
//
import infoBip from 'Scripts/components/sms'
import { isTouchDevice } from '../utils/utils'
import MyCookie from 'Scripts/utils/Cookie'

export default class Mapbox {

  constructor({ selector, zoom, center, data }) {
    this.selector = selector
    this.center = center || [-7.6570322, 33.5722678]
    this.zoom = zoom
    this.data = data || []
    this.listings = document.querySelector('.map__sidebar_listings')
    //Prepare data
    this.setGeoJSON()
    //Init Map
    this.initMap()
    //Add markers to Map
    this.map && this.setMarkers()
    //
    // this.addEventListener()
    //

    // console.log(mapIcon)
    // console.log(this.map.boxZoom.isEnabled())
  }

  initMap() {
    mapboxgl.accessToken = process.env.MAPBOX

    this.map = new mapboxgl.Map({
      container: this.selector,
      // style: 'mapbox://styles/mapbox/streets-v11',
      // style: 'mapbox://styles/mapbox/light-v10',
      style: 'mapbox://styles/enbprojects/cl8tapu1o001714pcu8aw4sr0',
      center: this.center,
      zoom: this.zoom,
      projection: 'globe',
      scrollZoom: true,
      cooperativeGestures: !isTouchDevice(),
      language: 'fr',
      worldview: 'MA',
      attributionControl: false

    })

    this.map.on('style.load', () => { this.map.setFog({}) })
    //Set Controls
    this.setControls()

    // this.map.setLayoutProperty('country-label', 'text-field', [
    //   'get',
    //   `name_fr`
    // ])
  }

  setControls() {
    // Add Full Screen Control
    this.map.addControl(new mapboxgl.FullscreenControl(), 'top-right')


    this.map.addControl(new mapboxgl.AttributionControl({
      customAttribution: 'Map design by <a href="http://embprojects.com/" target="_blank">Studio MB</a>'
    }), 'bottom-right')

    // Add zoom and rotation controls to the map.
    this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')
    // Add Geolocate control


    //Add Geocoder
    this.geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken, // Set the access token
      mapboxgl: mapboxgl, // Set the mapbox-gl instance
      countries: 'ma', // Limit seach results to Morocco
      marker: {
        color: '#f6a31c'
      }, // Use the geocoder's default marker style
      placeholder: 'Rechercher une adresse',
      enableGeolocation: true
    })
    //Add inside the map 
    this.map.addControl(this.geocoder, 'top-left')
    //Add outside the map
    // document.querySelector('#geocoder')?.appendChild(this.geocoder.onAdd(this.map))

    //Add Geolocation
    // this.map.addControl(new mapboxgl.GeolocateControl({
    //   positionOptions: {
    //     enableHighAccuracy: true
    //   },
    //   trackUserLocation: true,
    //   showUserHeading: true
    // }), 'top-right')

  }

  setMarkers() {
    this.map.on('load', () => {
      //Add Icon to Carte style
      this.map.loadImage(`${process.env.MADMOUN}/wp-content/themes/madmoun/img/map-64.png`, (error, image) => {
        if (error) throw error
        this.map.addImage('madmoun', image)
      })
      //Add source         
      this.map.addSource('agences', this.geoJSON)
      //Add Layers : clusters, markers
      this.setLayers()
      //Init listeners
      this.initListeners()
      //Build Listings
      this.buildListing()
    })
  }

  setGeoJSON() {
    const features = []

    this.data.forEach((elm) => {
      // console.log(elm)
      features.push({
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [parseFloat(elm.lng), parseFloat(elm.lat)]
        },
        "properties": {
          id: elm.id,
          title: elm.title.toLowerCase(),
          adresse: elm.adresse.toLowerCase(),
          gsm: elm.gsm,
          email: elm.email,
          ville: elm.ville.toLowerCase(),
          type: elm.type,

        }
      })
    })

    this.geoJSON = {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: features
      },
      cluster: true,
      clusterMaxZoom: 12, // Max zoom to cluster points on
      clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    }

  }

  setLayers() {
    //Add Clusters
    this.map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: 'agences',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': '#257d76',
        'circle-radius': 20
      }
    })
    //Add Clusters count
    this.map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: 'agences',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      },
      paint: {
        'text-color': "#FFFFFF"
      }
    })
    // Add a symbol layer
    this.map.addLayer({
      id: 'unclustered',
      type: 'symbol',
      source: 'agences',
      filter: ['!', ['has', 'point_count']],
      layout: {
        'icon-image': 'madmoun',
        'icon-size': 0.6
      },
      paint: {
        'icon-color': '#257d76',
      }
    })
  }

  initListeners() {
    // inspect a cluster on click
    this.map.on('click', 'clusters', (e) => {
      const features = this.map.queryRenderedFeatures(e.point, {
        layers: ['clusters']
      })
      const clusterId = features[0].properties.cluster_id
      this.map.getSource('agences').getClusterExpansionZoom(
        clusterId,
        (err, zoom) => {
          if (err) return
          this.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          })
        }
      )
    })

    // When a click event occurs on a feature in
    // the unclustered-point layer, open a popup at
    // the location of the feature, with
    // description HTML from its properties.
    this.map.on('click', 'unclustered', (e) => {
      //Re center map
      this.flyToStore(e.features[0])
      //Create Popup
      this.createPopUp(e.features[0])

      /* Highlight listing in sidebar */
      const activeItem = document.querySelector('.map__item.is__active')
      // e.stopPropagation()
      activeItem && activeItem.classList.remove('is__active')
      const listing = document.querySelector(`#map__item-${e.features[0].properties.id}`)
      listing.classList.add('is__active')

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.

      const coordinates = e.features[0].geometry.coordinates.slice()
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
      }
    })

    //
    this.geocoder.on('result', (e) => {
      const searchResult = e.result.geometry

      //Add distance to store
      for (const store of this.geoJSON.data.features) {
        store.properties.distance = distance(searchResult, store.geometry)
      }
      //Sort store by distance
      this.geoJSON.data.features.sort((a, b) => {
        if (a.properties.distance > b.properties.distance) {
          return 1
        }
        if (a.properties.distance < b.properties.distance) {
          return -1
        }
        return 0 // a must be equal to b
      })

      while (this.listings.firstChild) {
        this.listings.removeChild(this.listings.firstChild)
      }
      this.buildListing()

      //Highlight the closest store's listing
      document.getElementById(`map__item-${this.geoJSON.data.features[0].properties.id}`).classList.add('is__active')

      //Fit bounds to search result and closest store         
      this.map.fitBounds(this.getBbox(this.geoJSON.data, 0, searchResult), { padding: 100 })
      this.createPopUp(this.geoJSON.data.features[0])

    })

    // document.querySelector('.mapboxgl-ctrl-geolocate').addEventListener('click', () => {
    //   console.log('Geolocation')
    // })

  }

  buildListing() {
    // console.log(this.geoJSON.data.features)
    for (const store of this.geoJSON.data.features) {
      //
      const distance = store.properties.distance ? `${Math.round(store.properties.distance * 100) / 100} Km` : ''
      const adresse = store.properties.adresse ? `${store.properties.adresse}, ` : ''
      //    
      const tel = this.formatTel(store.properties.gsm)
      //
      this.listings.innerHTML += `
      <div id="map__item-${store.properties.id}" class="map__item" data-id="${store.properties.id}" id="map__item_link-${store.properties.id}">
        <div class="map__item_info">
          <div class="map__item_title">${this.formatTitle(store.properties.title)}</div>          
          <div class="map__item_adresse">${adresse + store.properties.ville}</div>
          <div>          
            <a href="tel:${tel}" target="_blank" rel="nofollow" class="map__item_phone">${tel}</a>
          </div>
        </div>  
        <div class="map__item_additional">
          <div class="map__item_distance">${distance}</div>
        </div>        
      </div>`

    }


    document.querySelectorAll('.map__item').forEach(elm => {
      elm.addEventListener('click', () => {
        // console.log(elm.dataset.id)
        for (const feature of this.geoJSON.data.features) {
          if (parseInt(elm.dataset.id) === feature.properties.id) {
            this.flyToStore(feature)
            this.createPopUp(feature)
          }
        }
        const activeItem = document.querySelector('.map__item.is__active')
        activeItem && activeItem.classList.remove('is__active')
        elm.classList.add('is__active')
      })
    })

  }

  flyToStore(currentFeature) {

    // console.log(this.map.getZoom())
    // const zoom = this.map.getZoom()
    this.map.flyTo({
      center: currentFeature.geometry.coordinates,
      // zoom: zoom > 10 ? zoom : 10
      zoom: 12
    })
  }

  createPopUp(currentFeature) {
    const popUps = document.querySelector('.mapboxgl-popup')
    /** Check if there is already a popup on the map and if so, remove it */
    popUps && popUps.remove()
    //
    const tel = this.formatTel(currentFeature.properties.gsm)
    //
    const popupData = ` <header>${this.formatTitle(currentFeature.properties.title)}</header>
                        <main>
                          <div>${currentFeature.properties.adresse} ${currentFeature.properties.ville}</div>
                          <div><a href="tel:${tel}" target="_blank" rel="nofollow" class="map__item_phone">${tel}</a></div>
                          <div><a href="mailto:${currentFeature.properties.email}">${currentFeature.properties.email}</a></div>
                        </main>
                        <footer>                                
                          <a href="https://api.whatsapp.com/send?text=Localisez l’agence la plus proche pour vos transferts d’argent : ${encodeURIComponent(this.getLocalisation(currentFeature.geometry.coordinates[0], currentFeature.geometry.coordinates[1]))}" data-action="share/whatsapp/share">Partagez via WhatsApp</a> 
                        </footer>`

    // <footer>        
    //   <h6>Envoyer la localisation</h6>
    //   <input type="text" name='sendSMS' class='sendSMS' placeholder='0612345678' data-lng="${currentFeature.geometry.coordinates[0]}" data-lat="${currentFeature.geometry.coordinates[1]}"/>
    //   <h6 class="error">Merci de saisir un numéro de téléphone valide</h6>  
    // </footer>

    //<a href="#" class="sendSMS" data-lng="${currentFeature.geometry.coordinates[0]}" data-lat="${currentFeature.geometry.coordinates[1]}">Envoyer la localisation</a>

    new mapboxgl.Popup({ closeOnClick: true })
      .setLngLat(currentFeature.geometry.coordinates)
      .setHTML(popupData)
      .addTo(this.map)

    this.sendSMS()
  }

  addMarker(lngLat) {
    new mapboxgl.Marker({ color: '#257d76', rotation: 45 })
      .setLngLat(lngLat)
      .addTo(this.map)
  }

  getBbox(sortedStores, storeIdentifier, searchResult) {
    const lats = [
      sortedStores.features[storeIdentifier].geometry.coordinates[1],
      searchResult.coordinates[1]
    ]
    const lons = [
      sortedStores.features[storeIdentifier].geometry.coordinates[0],
      searchResult.coordinates[0]
    ]
    const sortedLons = lons.sort((a, b) => {
      if (a > b) {
        return 1
      }
      if (a.distance < b.distance) {
        return -1
      }
      return 0
    })
    const sortedLats = lats.sort((a, b) => {
      if (a > b) {
        return 1
      }
      if (a.distance < b.distance) {
        return -1
      }
      return 0
    })
    return [
      [sortedLons[0], sortedLats[0]],
      [sortedLons[1], sortedLats[1]]
    ]
  }

  sendSMS() {

    document.querySelector('.sendSMS')?.addEventListener('keydown', (e) => {
      // if (e.isComposing || e.keyCode === 229) {
      //   return;
      // }
      if (e.keyCode === 13) {
        const isPhone = /^0\d{9}$/.test(e.target.value)
        if (!isPhone) {
          e.target.nextElementSibling.classList.add('is__active')
        } else {
          e.target.nextElementSibling.classList.remove('is__active')
          const smsInfo = MyCookie.getCookie('smsInfo')
          if (smsInfo === null || parseInt(smsInfo) < 5) {
            const { lng, lat } = e.target.dataset
            new infoBip({ selector: e.target, to: this.formatTel(e.target.value), msg: `Localisez l’agence la plus proche pour vos transferts d’argent : ${this.getLocalisation(lng, lat)}` })
          } else {
            e.target.parentNode.innerHTML = 'Vous avez dépassé le quota autorisé'
          }
        }

      }
    })

    // document.querySelector('.sendSMS')?.addEventListener('click', (e) => {
    //   e.preventDefault()    
    //   const { lng, lat } = e.target.dataset    
    //   new infoBip({ selector: e.target, to: '212662266427', msg: `Pour envoyer/recevoir de l'argent de notre agence : ${this.getLocalisation(lng, lat)}` })
    // })
  }

  getLocalisation(lng, lat) {
    return lng && lat ? `https://www.google.com/maps/search/?api=1&query=${lat},${lng}` : ''
  }

  formatTel(tel) {
    return tel.startsWith('212') ? tel.replace('212', '+212') : tel.startsWith('0') ? tel.replace('0', '+212') : tel
  }

  formatTitle(title) {
    return title.startsWith('fondation arrawaj') ? title.replace('fondation arrawaj ', '') : title
  }


  // this.map.on('mouseenter', 'clusters', () => {
  //     this.map.getCanvas().style.cursor = 'pointer'
  // })
  // this.map.on('mouseleave', 'clusters', () => {
  //     this.map.getCanvas().style.cursor = ''
  // })


}


